import RequiredTip from './RequiredTip'

export default RequiredTip
